'use client'
import { useState, FormEvent } from 'react'
import { ArrowRight, ChevronDown } from 'lucide-react'
import { postNewsletterSubscribers } from '@/lib/actions'
import { notify } from '@/utils/notification'
import type { TagDataType } from '@/interfaces/pages'
import './styles.scss'

interface ISubscribeFormProps {
  segments: TagDataType[]
}
export const SubscribeForm = ({ segments }: ISubscribeFormProps) => {
  const [email, setEmail] = useState('')
  const [selectedSegment, setSelectedSegment] = useState<TagDataType | null>(
    null,
  )
  const [showSegmentDropdown, setShowSegmentDropdown] = useState(false)
  const [segmentError, setSegmentError] = useState(false)

  const handleNewsletterSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (!selectedSegment) {
      setSegmentError(true)
      return
    }
    const response = await postNewsletterSubscribers({
      data: {
        email,
        tag: selectedSegment.title,
      },
    })
    if ('error' in response) {
      notify(
        'Houve um erro na solicitação. Tente novamente mais tarde.',
        'error',
      )
    } else {
      notify('Cadastro feito com sucesso!', 'success')
      setEmail('')
      setSelectedSegment(null)
      setSegmentError(false)
    }
  }

  return (
    <form className="subscribe-form" onSubmit={handleNewsletterSubmit}>
      <div className="segment-dropdown-wrapper">
        <button
          type="button"
          className={`segment-dropdown-button${segmentError ? ' --error' : ''}`}
          aria-haspopup="listbox"
          aria-expanded={showSegmentDropdown}
          aria-label="Selecionar segmento do equipamento"
          onClick={() => {
            setShowSegmentDropdown(!showSegmentDropdown)
            setSegmentError(false)
          }}
        >
          <span>{selectedSegment?.title || 'Selecione seu Segmento'}</span>
          <ChevronDown size={24} />
        </button>
        {segmentError && (
          <span className="segment-error-message" role="alert">
            Selecione um segmento antes de continuar.
          </span>
        )}
        {showSegmentDropdown && (
          <ul
            className="segment-dropdown-menu"
            role="listbox"
            aria-label="Segmentos disponíveis"
          >
            {segments.map((segment) => (
              <li
                key={segment.id}
                role="option"
                aria-selected={selectedSegment?.id === segment.id}
              >
                <button
                  type="button"
                  className="segment-option"
                  onClick={() => {
                    setSelectedSegment(segment)
                    setShowSegmentDropdown(false)
                    setSegmentError(false)
                  }}
                >
                  {segment.title}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>

      <input
        type="email"
        placeholder="email@exemplo.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />

      <button
        type="submit"
        className="subscribe-button"
        aria-label="Inscrever-se na newsletter"
      >
        <ArrowRight size={24} />
      </button>
    </form>
  )
}
